// extracted by mini-css-extract-plugin
module.exports = {"container":"shop-by-shape-thumbnail_container__X66M_","text":"shop-by-shape-thumbnail_text__g6Vi8"};